<dl class="dl-horizontal" *ngIf="options?.length > 0">
  <dt class="dl-horizontal-dt"><label for="{{idName}}" (click)="filterList.focus()">{{filterLabel}}</label></dt>
  <dd class="dl-horizontal-dd">
    <ul id="{{idName}}" attr.aria-label="{{ i18nLanguageWords.filterBy }}" role="listbox" tabindex="-1" #filterList>
      <!-- <a role="button" title="{{ i18nLanguageWords.all }}" href="javascript: void(0)"
          role="option" aria-disabled="false" [class.active]="isAllCheck" [attr.aria-selected]="isAllCheck"
          (click)="toggleAll()"><li><span>{{ i18nLanguageWords.all }}</span></li></a>
      <a role="button" title="{{data.label}}" href="javascript: void(0)" *ngFor="let data of options"
          role="option" aria-disabled="false" [class.active]="data.checked" [attr.aria-selected]="data.checked"
          (click)="toggleOne(data)"><li><span>{{data.label}}</span></li></a> -->
      <li role="option">
        <a role="button" title="{{ i18nLanguageWords.all }}" href="javascript: void(0)" [class.active]="isAllCheck" [attr.aria-selected]="isAllCheck"
        (click)="toggleAll()">{{ hasCancelAll ? ( isAllCheck ? i18nLanguageWords.cancelAll : i18nLanguageWords.all) : i18nLanguageWords.all }}</a>
      </li>
      <li role="option" *ngFor="let data of options">
        <a role="button" title="{{data.label}}" href="javascript: void(0)" [class.active]="data.checked"  [attr.aria-selected]="data.checked"
        (click)="toggleOne(data)">{{data.label}}</a>
      </li>
    </ul>
  </dd>
</dl>
